export default {"src":"/pro/_next/static/media/ondo.d1c5d68a.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};